import { AssignmentStatus } from '../../Assignment/enums/AssignmentStatus';
import { useGetStatusCounterQuery } from '../services/fleetDashboard.service';

interface UseGetStatusCountersProps {
  pollingInterval: number;
}

interface StatusCount {
  status: AssignmentStatus;
  total: number;
}

const useGetStatusCounters = ({
  pollingInterval,
}: UseGetStatusCountersProps) => {
  const { data = [], isLoading } = useGetStatusCounterQuery(undefined, {
    pollingInterval,
  });

  const pendingReports: StatusCount = {
    status: AssignmentStatus.PENDING,
    total:
      data.find((item) => item.status === AssignmentStatus.PENDING)?.count ?? 0,
  };

  const reportsByStatus: StatusCount[] = [
    AssignmentStatus.IN_PROCESS,
    AssignmentStatus.SUSPENDED,
    AssignmentStatus.FINISHED,
  ].map((status) => ({
    status,
    total: data.find((item) => item.status === status)?.count ?? 0,
  }));

  return {
    pendingReports,
    reportsByStatus,
    isLoading
  };
};

export default useGetStatusCounters;
